<div
  *ngIf="hasScopedObjectId$ | async"
  class="unscope-object-container"
  [class.nesting-target]="isNestingTarget$ | async"
>
  <mat-icon class="material-symbols-outlined"> chevron_left </mat-icon>
  <h3-annotation-label
    class="overline"
    [annotationType]="'object'"
    [annotationId]="scopedObjectId$ | async"
  ></h3-annotation-label>
</div>
